import { motion } from "framer-motion";

const items = [
  "M.Ch — Urology",
  "Robotic Surgery · Intuitive Surgicals USA",
  "Laparoscopy · Aesculap Academy Germany",
  "Kidney Transplantation",
  "Da Vinci Certified",
  "15+ Years of Practice",
  "10,000+ Patients",
  "Urological Society of India",
];

export const Marquee = () => (
  <motion.section
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 0.8 }}
    className="relative bg-forest text-white py-5 overflow-hidden"
  >
    <div className="marquee gap-14 whitespace-nowrap">
      {[...items, ...items].map((t, i) => (
        <span
          key={i}
          className="flex items-center gap-14 text-[11px] tracking-[0.22em] uppercase font-mono font-medium"
        >
          {t}
          <span className="text-terra-soft">✦</span>
        </span>
      ))}
    </div>
  </motion.section>
);
